import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listLogs:[],
  resultLogs:[],
};
export const mutations = {
  GET_LOGS({ context }, logs) {
    state.listLogs = Object.assign({}, logs);
  },

  CONSULTAR_LOGS({ context }, logs) {
    // state.loading = false;
    // // state.resultCedula = Object.assign({}, result_cedulas);
    // if (logs) {
    //   let logs = [];
    //   Object.entries(result_logs).forEach(([key, val]) => logs.push(val));
    //   return (state.resultLogs = logs);
      state.resultLogs = Object.assign({}, logs);
    // }
  },

};
export const actions = {
  GET_LOGS({ commit }) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getLogs()
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("GET_LOGS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

    CONSULTAR_LOGS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        console.log(data);
        ApiService.getLogsPaginate(data)
          .then(response => {
            //console.log(response.data);
            // if (response.data.msg == 'No Data') {
            //   commit("DATA_NOT_FOUND", data);
            // }
            commit("SET_LOADING", false);
            commit("CONSULTAR_LOGS", response.data);
            resolve(response);
          })
          .catch(error => {
            commit("SET_LOADING", false);
            reject(error);
          });
      });
    },
};
export const getters = {//leer datos
  listLogs: state => state.listLogs,
  resultLogs: state => state.resultLogs
};
